import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import PDPInfoTable from '../PDPInfoTable';
import PDPDimensionsImage from './PDPDimensionsImage';
const PDPDimensionsContentUI = t0 => {
  const $ = _c(30);
  const {
    dimensionsDesktopImage,
    dimensionsMobileImage,
    dimensions: t1,
    boxDimensions: t2,
    loading: t3,
    onImageClick,
    isSidebarContent: t4,
    hasCylindoDimensionShots: t5,
    dimensionShotUrls: t6,
    currentDimensionShot,
    selectedDimensionShotIndex: t7,
    setSelectedDimensionShotIndex
  } = t0;
  let t8;
  if ($[0] !== t1) {
    t8 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const dimensions = t8;
  let t9;
  if ($[2] !== t2) {
    t9 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const boxDimensions = t9;
  const loading = t3 === undefined ? false : t3;
  const isSidebarContent = t4 === undefined ? false : t4;
  const hasCylindoDimensionShots = t5 === undefined ? false : t5;
  let t10;
  if ($[4] !== t6) {
    t10 = t6 === undefined ? [] : t6;
    $[4] = t6;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  const dimensionShotUrls = t10;
  const selectedDimensionShotIndex = t7 === undefined ? 0 : t7;
  let t11;
  if ($[6] !== loading) {
    t11 = loading && <Placeholder loading={true} type="rect" style={{
      marginRight: 0,
      marginTop: "10px",
      height: "207px"
    }} />;
    $[6] = loading;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== currentDimensionShot || $[9] !== dimensionShotUrls || $[10] !== dimensionsDesktopImage || $[11] !== dimensionsMobileImage || $[12] !== hasCylindoDimensionShots || $[13] !== isSidebarContent || $[14] !== loading || $[15] !== onImageClick || $[16] !== selectedDimensionShotIndex || $[17] !== setSelectedDimensionShotIndex) {
    t12 = !loading && <PDPDimensionsImage dimensionsDesktopImage={dimensionsDesktopImage} dimensionsMobileImage={dimensionsMobileImage} onImageClick={onImageClick} isSidebarContent={isSidebarContent} hasCylindoDimensionShots={hasCylindoDimensionShots} dimensionShotUrls={dimensionShotUrls} currentDimensionShot={currentDimensionShot} selectedDimensionShotIndex={selectedDimensionShotIndex} setSelectedDimensionShotIndex={setSelectedDimensionShotIndex} />;
    $[8] = currentDimensionShot;
    $[9] = dimensionShotUrls;
    $[10] = dimensionsDesktopImage;
    $[11] = dimensionsMobileImage;
    $[12] = hasCylindoDimensionShots;
    $[13] = isSidebarContent;
    $[14] = loading;
    $[15] = onImageClick;
    $[16] = selectedDimensionShotIndex;
    $[17] = setSelectedDimensionShotIndex;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== dimensions || $[20] !== loading) {
    t13 = <div className="max-w-[480px] mx-auto my-0"><PDPInfoTable items={dimensions} loading={loading} /></div>;
    $[19] = dimensions;
    $[20] = loading;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== boxDimensions || $[23] !== loading) {
    t14 = boxDimensions?.length > 0 && <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0]"><div className="max-w-[480px] mx-auto my-0"><h2 className="text-xl font-bold text-gray">{loading ? <Placeholder type="rect" loading={true} style={{
            height: "28px",
            width: "220px"
          }} /> : "Shipping Dimensions"}</h2></div><div className="max-w-[480px] mx-auto my-0"><PDPInfoTable items={boxDimensions} loading={loading} /></div></div>;
    $[22] = boxDimensions;
    $[23] = loading;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t14) {
    t15 = <div className="PDPDimensionsContentUI">{t11}{t12}{t13}{t14}</div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
};
PDPDimensionsContentUI.propTypes = {
  dimensions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  boxDimensions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  dimensionsDesktopImage: PropTypes.string,
  dimensionsMobileImage: PropTypes.string,
  loading: PropTypes.bool,
  isSidebarContent: PropTypes.bool,
  onImageClick: PropTypes.func,
  hasCylindoDimensionShots: PropTypes.bool,
  dimensionShotUrls: PropTypes.arrayOf(PropTypes.object),
  currentDimensionShot: PropTypes.shape({
    src: PropTypes.string.isRequired,
    dimensionCode: PropTypes.string.isRequired
  }),
  selectedDimensionShotIndex: PropTypes.number,
  setSelectedDimensionShotIndex: PropTypes.func
};
export default PDPDimensionsContentUI;